/**
 * Modal Delete.
 */
$("body").on("click", ".modal-delete", function (e) {
    e.preventDefault();
    let url = $(this).attr("data-url");
    $('#modal-delete form').attr('action', url);
});
